export default __webpack_public_path__ + "static/media/Stalker's Veil of the Black Arts.d0488455.jpg";